module.exports = __webpack_public_path__ + "img/bamboo-watch.b4dbc2b4.jpg";